import { useEffect, useState } from 'react';

const DURATION_MS = (17 * 60 + 34) * 1000; // 00:17:34
const START = Date.now();

function remainingMs(): number {
  const elapsed = (Date.now() - START) % DURATION_MS;
  return DURATION_MS - elapsed;
}

/** Shared, synchronized countdown that restarts automatically at 00:17:34. */
export function useCountdown() {
  const [ms, setMs] = useState(remainingMs);

  useEffect(() => {
    const id = window.setInterval(() => setMs(remainingMs()), 250);
    return () => window.clearInterval(id);
  }, []);

  const total = Math.ceil(ms / 1000) % (DURATION_MS / 1000 + 1);
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}
